/**
 * @file index
 * @author WangZhuang
 */

import * as attest from './attest';
import * as appeal from './appeal';
import * as inqueiry from './inqueiry';
import * as mark from './mark';
import * as verifyMsg from './verifyMsg';
import * as myAttest from './myAttest';
import * as locationPage from './locationPage';

export default Object.assign(
    {},
    attest,
    appeal,
    inqueiry,
    mark,
    verifyMsg,
    myAttest,
    locationPage
);
